<template>
  <a-select
    :placeholder="`请选择${item.title}`"
    :mode="mode"
    :value="copyValue"
    :options="options"
    allowClear
    @change="handleChange"
  >
  </a-select>
</template>

<script>
export default {
  props: {
    value: {
      type: [String, Number, Array],
      default: ""
    },
    item: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  watch: {
    item: {
      async handler(val) {
        const res = await this.axios.get(
          "/common/dict/item?code=" + val.dictCode
        );
        this.options = res.result.map(item => ({
          value: item.itemValue,
          label: item.itemText
        }));
      },
      deep: true,
      immediate: true
    },
    value: {
      handler(val) {
        if (this.item.type === "mutiSelect") {
          this.copyValue = val ? val.split(",") : [];
        } else {
          this.copyValue = val;
        }
      },
      immediate: true
    }
  },
  data() {
    return {
      options: [],
      copyValue: ""
    };
  },
  computed: {
    mode() {
      return this.item.type === "mutiSelect" ? "multiple" : "default";
    }
  },
  methods: {
    handleChange(val) {
      const value = this.item.type === "mutiSelect" ? val.join(",") : val;
      this.$emit("change", value);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/common/components/dictSelect.vue